import { Grid } from "lucide-react";

export const CategorySidebar = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <div className="w-48 flex-shrink-0 bg-black/50 border-r border-gray-800 overflow-y-auto" data-testid="category-sidebar">
      <div className="p-2">
        <button
          onClick={() => onSelectCategory(null)}
          className={`w-full flex items-center gap-2 px-3 py-2 rounded text-sm transition-colors ${
            !selectedCategory ? 'bg-red-600 text-white' : 'text-gray-300 hover:bg-white/10'
          }`}
        >
          <Grid size={16} />
          All Channels
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => onSelectCategory(cat.id)}
            className={`w-full flex items-center justify-between gap-2 px-3 py-2 rounded text-sm transition-colors ${
              selectedCategory === cat.id ? 'bg-red-600 text-white' : 'text-gray-300 hover:bg-white/10'
            }`}
          >
            <span className="flex items-center gap-2">
              <span>{cat.icon}</span>
              <span className="truncate">{cat.name}</span>
            </span>
            <span className="text-xs opacity-60">{cat.channel_count}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export const ChannelCard = ({ channel, onSelect, isSelected }) => {
  const currentProgram = channel.current_program;
  return (
    <div 
      onClick={() => onSelect(channel)}
      className={`cursor-pointer rounded-lg overflow-hidden transition-all hover:scale-105 ${isSelected ? 'ring-2 ring-red-600' : ''}`}
      data-testid={`channel-card-${channel.id}`}
    >
      <div className="relative aspect-video bg-gray-900">
        {currentProgram?.thumbnail ? (
          <img src={currentProgram.thumbnail} alt={currentProgram.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <img src={channel.logo} alt={channel.name} className="w-16 h-16 rounded" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
        <div className="absolute top-2 left-2 bg-black/70 px-2 py-1 rounded text-xs font-bold">{channel.number}</div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-red-600 px-2 py-1 rounded text-xs font-bold">
          <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />
          LIVE
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-2 mb-1">
            <img src={channel.logo} alt="" className="w-6 h-6 rounded" />
            <span className="font-bold text-sm truncate">{channel.name}</span>
          </div>
          {currentProgram && <p className="text-xs text-gray-300 truncate">{currentProgram.title}</p>}
        </div>
      </div>
    </div>
  );
};
